import React, { useState } from "react";
import CustomCheckBox from "../GlobalComponents/CustomCheckBox";
import CustomRadio from "../GlobalComponents/CustomRadio";
import { Loader, Loader2 } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import RedDotCircle from "../RedDotCircle";

interface IProps {
  title: string;
  List: {
    label?: string;
    quantity?: number;
    id?: string;
  }[];
  onListClick: (item: any) => void;
  showCheckBox?: boolean;
  showRadio?: boolean;
  loading?: boolean;
  loadingText?: string;
  selectedItem?: any;
  borderBottom?: boolean;
  collapsable?: boolean;
  defaultCollapsed?: boolean;
  id?: string;
  isSelectedHighlight?: boolean;
}

const SideTabList = ({
  title,
  List,
  onListClick,
  showCheckBox = false,
  showRadio = false,
  loading = false,
  loadingText = "Loading...",
  selectedItem = [],
  borderBottom = true,
  collapsable = false,
  defaultCollapsed = true,
  id = "",
  isSelectedHighlight = false,
}: IProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  return (
    <div
      className={`w-full px-2 2xl:px-3 pt-2  2xl:pt-3 ${
        !collapsable ? "2xl:pb-3 xl:pb-2 pb-1" : "2xl:pb-2 xl:pb-1.5 pb-1"
      } ${borderBottom ? "border-b border-gray-300" : "border-none"}`}
    >
      <div
        className={`flex items-center justify-between ${
          collapsable ? "cursor-pointer" : ""
        }`}
        onClick={() => {
          if (collapsable) {
            setIsCollapsed(!isCollapsed);
          }
        }}
      >
        <h2
          className={`font-Poppins-Medium font-size-18px theme-color-green ${
            isSelectedHighlight ? "flex items-center gap-1" : ""
          }`}
        >
          {title}
          {isSelectedHighlight &&
          (showRadio ? selectedItem : selectedItem?.length > 0) ? (
            <RedDotCircle
              count={showRadio ? 1 : selectedItem?.length}
              className="relative !top-0 !right-0"
              showCount
            />
          ) : null}
        </h2>
        {collapsable && (
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`font-size-16px mt-[-2px] mr-1 text-[#004540] ${
              isCollapsed ? "rotate-180" : ""
            }`}
          />
        )}
      </div>
      <div
        className={`w-full flex flex-col 2xl:gap-3 xl:gap-2 gap-1 mt-2 custom-ai-scroll-bar transition-all duration-300 ${
          isCollapsed && collapsable
            ? "max-h-[0px] overflow-hidden"
            : `${
                collapsable ? "max-h-[60vh]" : "max-h-[400px]"
              }  overflow-y-auto`
        }`}
      >
        {!loading && List?.length > 0
          ? List?.map((item, index) => (
              <button
                key={Math.random() * index}
                className="w-full flex items-center 2xl:gap-2 gap-1.5 cursor-pointer"
                id={`${id || "list-tab"}-${index + 1}`}
                onClick={() => {
                  if (showCheckBox || showRadio) {
                    onListClick(item);
                  }
                }}
              >
                {showCheckBox && (
                  <CustomCheckBox
                    id={`list-checkbox-${index + 1}`}
                    checked={selectedItem?.includes(item?.id) || false}
                    onChange={() => {}}
                  />
                )}
                {showRadio && (
                  <CustomRadio
                    checked={selectedItem === item?.id || false}
                    // onChange={() => {
                      
                    // }}
                    onClick={() => {
                      if (showCheckBox || showRadio) {
                        onListClick(item);
                      }
                    }}
                  />
                )}
                <p className="font-Poppins-Regular lowercase first-letter:capitalize truncate max-w-[calc(100%-35px)] font-size-15px text-[#2D2D2D]">
                  {item.label}
                </p>
                {item.quantity && (
                  <p className="font-Poppins-Regular font-size-15px text-[#2D2D2D]">
                    ({item.quantity})
                  </p>
                )}
              </button>
            ))
          : !loading && (
              <div className="w-full flex items-center justify-center h-[60px] gap-2">
                <p className="font-Poppins-Regular font-size-15px text-[#2D2D2D] text-center lowercase first-letter:uppercase">
                  No {title} found
                </p>
              </div>
            )}

        {loading && (
          <div className="w-full flex items-center justify-center h-[100px] gap-2">
            <Loader className="w-6 h-6 animate-spin" />
            <p className="font-Poppins-Regular font-size-15px text-[#2D2D2D]">
              {loadingText}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideTabList;
